import { render, staticRenderFns } from "./EdenAttachmentsUpload.vue?vue&type=template&id=c8b94548&scoped=true"
import script from "./EdenAttachmentsUpload.vue?vue&type=script&lang=js"
export * from "./EdenAttachmentsUpload.vue?vue&type=script&lang=js"
import style0 from "./EdenAttachmentsUpload.vue?vue&type=style&index=0&id=c8b94548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b94548",
  null
  
)

export default component.exports